var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaretDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59372 8.90907L11.1459 16.5553C11.2515 16.6785 11.3825 16.7774 11.53 16.8452C11.6774 16.913 11.8377 16.9481 12 16.9481C12.1622 16.9481 12.3226 16.913 12.47 16.8452C12.6174 16.7774 12.7484 16.6785 12.854 16.5553L19.4062 8.90907C20.0315 8.17922 19.5131 7.05188 18.5522 7.05188H5.44591C4.48497 7.05188 3.96653 8.17922 4.59372 8.90907Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaretDown);
export default __webpack_public_path__ + "static/media/Caret-Down.fa6e9e9f8b902336d94a2d4afbdb97b6.svg";
export { ForwardRef as ReactComponent };